import { Suspense, lazy } from "react";

import { BrowserRouter, Route, Routes } from "react-router-dom";

import customLoader from "./Assets/images/common/custom_loader.gif";

const LandingPage = lazy(() => import("./features/landing/LandingPage"));
const AboutUsPage = lazy(() => import("./features/about/AboutUsPage"));
const BookADemoPage = lazy(() => import("./features/book-a-demo/BookADemoPage"));
const PricingPage = lazy(() => import("./features/pricing/PricingPage"));
const ContactUsPage = lazy(() => import("./features/contact/ContactUsPage"));
const ProductsPage = lazy(() => import("./features/products/ProductsPage"));
const NewsPage = lazy(() => import("./features/news/NewsPage"));
const TermsAndConditionPage = lazy(() => import("./features/legal/TermsAndConditionPage"));
const PrivacyPage = lazy(() => import("./features/legal/PrivacyPage"));
const DownloadApp = lazy(() => import("./features/download-app/DownloadAppPage"));
const DeleteAccountInfo = lazy(() => import("./features/delete-account/DeleteAccountInfoPage"));

const PageNotFound = lazy(() => import("./features/not-found/PageNotFound"));

function AppRoutes() {
  return (
    <Suspense
      fallback={<img src={customLoader} className="custom-loader" alt="loading..." height="70px" width="70px" />}
    >
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<LandingPage />} />
          <Route exact path="/about-us" element={<AboutUsPage />} />
          <Route exact path="/products" element={<ProductsPage />} />
          <Route exact path="/pricing" element={<PricingPage />} />
          <Route exact path="/news" element={<NewsPage />} />
          <Route exact path="/contact-us" element={<ContactUsPage />} />
          <Route exact path="/book-a-demo" element={<BookADemoPage />} />
          <Route exact path="/download-app" element={<DownloadApp />} />
          <Route exact path="/delete-account-info" element={<DeleteAccountInfo />} />
          <Route exact path="/terms-and-conditions" element={<TermsAndConditionPage />} />
          <Route exact path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}

export default AppRoutes;
